import { useEffect, useState } from 'react';

/** Devolve `true` desde um `scroll` na janela até `idleMs` sem nenhum outro. */
export function useIsWindowScrolling(idleMs: number): boolean {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    let idleTimer: ReturnType<typeof setTimeout> | undefined;

    const handleScroll = () => {
      setIsScrolling(true);
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => setIsScrolling(false), idleMs);
    };

    globalThis.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      globalThis.removeEventListener('scroll', handleScroll);
      clearTimeout(idleTimer);
      setIsScrolling(false);
    };
  }, [idleMs]);

  return isScrolling;
}
